import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import SuperTokens from "supertokens-web-js";
import Session from "supertokens-web-js/recipe/session";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";

SuperTokens.init({
  appInfo: {
    appName: "My Awesome App",
    apiDomain: "http://localhost:3000",
    apiBasePath: "/auth",
  },
  recipeList: [Session.init()],
});

createApp(App).use(router).mount("#app");
